module.exports ={
  "propertyService": "https://ded2nt9g27.execute-api.us-east-1.amazonaws.com/test",
  "domusoApiService": "https://api.devmuso.com",
  "disbursementService": "https://1gnpjse3da.execute-api.us-east-1.amazonaws.com/test",
  "vantivService": "https://9l179zgmnc.execute-api.us-east-1.amazonaws.com/test",
  "reservationService": "https://2cvqdkhz4g.execute-api.us-east-1.amazonaws.com/test",
  "reportsService": "https://p6pci70tc1.execute-api.us-east-1.amazonaws.com/test",
  "postingBatchService": "https://1ia1f7yr4l.execute-api.us-east-1.amazonaws.com/test",
  "userPoolId": "us-east-1_SKREdeWi6",
  "userPoolWebClientId": "mmhq6lu0ueanh2pbefu9t8u5v",
  "appService": "https://app.devmuso.com",
  "payWithUrl": "https://paywith.devmuso.com",
  "emailLinkBase": "https://app.devmuso.com",
  "validations": {
    "ibfMerchantId": {
      "regex": "^\\d{6,9}$"
    }
  },
  "datadogEnabled": "false",
  "env": "test"
}